
// @group components

export default {
  name: 'ServiceHeaderComponent',
  props: ['data']
}
